import script from "./dialogBox.vue?vue&type=script&setup=true&lang=js"
export * from "./dialogBox.vue?vue&type=script&setup=true&lang=js"

import "./dialogBox.vue?vue&type=style&index=0&id=082e6de5&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-082e6de5"]])

export default __exports__